// *******************************************************************************
// Mod Filter
// *******************************************************************************

const galleryElem = document.querySelector('.gallery-module');

if (galleryElem) {
  // Toggle Reset Button
  const filterDropdownOpt = galleryElem.querySelectorAll('.mod-filter .dropdown__list-inner input');
  const searchInput = galleryElem.querySelector('#filter_search');

  filterDropdownOpt.forEach((input) => {
    input.addEventListener('change', (event) => {
      const parentEle = event.target.closest('.mod-filter');

      const resetButton = parentEle.querySelector(
        windowWidth() > breakpointMd ? '.mod-filter__left-footer' : '.mod-filter__reset-button',
      );

      const checkedOpt = parentEle.querySelector('.dropdown__list-inner input:checked');

      resetButton?.classList.toggle('hide', !checkedOpt);

      const selectedFilters = {};

      parentEle.querySelectorAll('.dropdown').forEach((dropdown) => {
        const placeholder = dropdown.querySelector('.dropdown__placeholder-text')?.dataset.placeholder;

        const selectedValues = [...dropdown.querySelectorAll('.dropdown__list-inner input:checked')].map(
          (input) => input.dataset.slug,
        );

        if (placeholder && selectedValues.length) {
          selectedFilters[placeholder] = selectedValues;
        }
      });

      axiosGetFilteredGalleryList(selectedFilters);
    });
  });

  const axiosGetFilteredGalleryList = async (filters) => {
    const formDataInput = {
      action: 'getFilteredGalleryList',
      filters,
      search: searchInput?.value.trim() || '',
    };

    try {
      const response = await axios.post(localData.siteURL, formDataInput);

      const galleryList = galleryElem.querySelector('.gallery-module__list');
      const notFound = galleryElem.querySelector('.gallery-module__not-found');

      const listHtml = response.data.data.list__html;
      const modalHtml = response.data.data.modal__html;
      const modalParent = galleryElem.closest('[data-modal-parent]');
      const modal = modalParent?.querySelector('.gallery-modal');

      if (listHtml) {
        galleryList.innerHTML = listHtml;
        galleryList
          .querySelectorAll('.fade-right, .fade-left, .fade-up')
          .forEach((el) => el.classList.remove('fade-right', 'fade-left', 'fade-up'));
        notFound?.classList.add('hide');
      } else {
        galleryList.innerHTML = '';
        notFound?.classList.remove('hide');
      }

      if (modal && modalHtml) {
        const closeButtonLabel = modal.querySelector('[data-close-modal]')?.getAttribute('aria-label');
        modal.outerHTML = modalHtml;

        const nextModal = modalParent.querySelector('.gallery-modal');
        if (closeButtonLabel && nextModal) {
          nextModal.querySelector('[data-close-modal]')?.setAttribute('aria-label', closeButtonLabel);
        }

        window.initGalleryModal?.();
      }
    } catch (err) {
      console.error(err);
    }
  };

  // Reset Options
  attachEvent('.mod-filter__reset-button', 'click', (ele) => {
    const parentEle = ele.target.closest(
      windowWidth() > breakpointMd ? '.mod-filter__left-footer' : '.mod-filter__reset-button',
    );

    parentEle.classList.add('hide');

    filterDropdownOpt.forEach((input) => {
      input.checked = false;
    });

    // Reset gallery
    axiosGetFilteredGalleryList([]);
  });

  // Toggle Filter
  const toggleFilter = (ele, toggle) => {
    const parentEle = ele.closest('.mod-filter');

    parentEle?.classList.toggle('is-open-modal', toggle);

    toggleBodyScrollLock(toggle);
  };

  attachEvent('.mod-filter__toggle', 'click', (ev) => {
    toggleFilter(ev.target, true);
  });

  attachEvent('.mod-filter-close', 'click', (ev) => {
    toggleFilter(ev.target, false);
  });

  onKeydown('escape', () => {
    galleryElem.querySelectorAll('.mod-filter.is-open-modal').forEach((ev) => {
      toggleFilter(ev, false);
    });
  });

  // Search
  searchInput?.addEventListener('keyup', async (event) => {
    const search = event.target.value.trim();

    const filters = {};

    galleryElem.querySelectorAll('.mod-filter .dropdown__list-inner input:checked').forEach((input) => {
      const dropdown = input.closest('.dropdown');

      const placeholder = dropdown?.querySelector('.dropdown__placeholder-text')?.dataset.placeholder;

      if (!placeholder) {
        return;
      }

      if (!filters[placeholder]) {
        filters[placeholder] = [];
      }

      filters[placeholder].push(input.dataset.slug);
    });

    if (search.length > 3) {
      await axiosGetFilteredGalleryList(filters, search);
    } else if (search.length === 0) {
      await axiosGetFilteredGalleryList(filters, '');
    }
  });
}
